
export const Types = {
    authenticatedUser  : '[Auth] Authentication',
    unauthenticatedUser  : '[Auth] Unauthenticated',
    
    responseMessage : {
        success : 'success',
        warning : 'warning',
        error : 'error'
    }	 
}
